import React from 'react';
import { useSelector } from 'react-redux';
import { Select, Form } from 'ui/components';
import * as Fi from 'react-icons/fi';

const initialState = {
  items: [
    {
      id: null,
      item: null,
      item_id: null,
      fraction: null,
      fraction_id: null,
      quantity: null,
    },
  ],
};

export const FormItems = ({ data, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [{ items }, setState] = React.useState(initialState);

  const $handleItemsChange = async (i, e, name) => {
    let newItems = [...items];
    if (e?.target?.name) {
      newItems[i][e.target.name] = e.target.valueNumber;
    } else {
      newItems[i][`${name}_id`] = e?.id;
      newItems[i][name] = e;
    }

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      items: [
        ...items,
        {
          item: null,
          item_id: null,
          fraction: null,
          fraction_id: null,
          quantity: null,
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...items];
    newItems.splice(i, 1);

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  React.useEffect(() => {
    const input = {
      items,
    };

    onInputChange(input);
  }, [items]);

  React.useEffect(() => {
    if (!data) return;

    let b = [];
    if (data) {
      data?.items?.forEach((i) => {
        b.push({
          id:i?.id,
          item: i?.item,
          item_id: i?.item?.id,
          fraction: i?.fraction,
          fraction_id: i?.fraction?.id,
          quantity: i?.quantity_planned / i?.fraction?.quantity,
        });
      });
    }
    setState((prevState) => ({ ...prevState, items: b }));
  }, [data]);

  React.useEffect(() => {
    if (data) return;

    setState({items: [
      {
        id: null,
        item: null,
        item_id: null,
        quantity: null,
      },
    ]});
  }, [])

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6">Data Item</div>
      <div className="py-3">
        {items?.map((e, i) => (
          <div className={'row align-items-end border-bottom py-3 m-0'} key={i}>
            <div className="col-11">
              <div className="row">
                <>
                  <div className="col-md-6 ps-0">
                    <div className="mb-3">
                      <Select.Remote
                        label="Pilih Item"
                        required
                        placeholder=""
                        url="/wms/item"
                        initialValue={e?.item_id}
                        keys={e?.item_id}
                        params={{ is_active: 'active' }}
                        name="item_id"
                        row={(d) => {
                          return {
                            value: d?.id,
                            label: d?.alias_name,
                          };
                        }}
                        onSelected={(e) => $handleItemsChange(i, e, 'item')}
                        errors={
                          StateForm?.errors?.items ||
                          StateForm?.errors[`items.${i}.item_id`]
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3 ps-0">
                    <div className="mb-3">
                      <Select.Remote
                        label="Pilih Fraction"
                        required
                        placeholder=""
                        url={`/wms/item/${e?.item?.id}/fractions`}
                        initialValue={e?.fraction_id}
                        name="fraction_id"
                        row={(d) => {
                          return {
                            value: d?.id,
                            label: d?.name,
                          };
                        }}
                        onSelected={(e) => $handleItemsChange(i, e, 'fraction')}
                        keys={e?.item_id}
                        disabled={!e?.item_id}
                        errors={
                          StateForm?.errors?.items ||
                          StateForm?.errors[`items.${i}.fraction_id`]
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3 ps-0">
                    <Form.Input
                      required
                      autoComplete="off"
                      label="Quantity"
                      name="quantity"
                      type="number"
                      value={e?.quantity}
                      onChange={(e) => $handleItemsChange(i, e)}
                      error={
                        StateForm?.errors[`items.${i}.quantity`]
                      }
                    />
                  </div>
                </>
              </div>
            </div>

            <div className="col-1 ps-0 ps-md-2 ">
              <button
                type="button"
                className="btn btn-danger rounded mb-3 p-2 mb-3"
                style={{ minHeight: 36, minWidth: '100%' }}
                onClick={() => $removeField(i)}
                disabled={items?.length === 1}
              >
                <Fi.FiX />
              </button>
            </div>
          </div>
        ))}

        <div className="mt-3">
          <button
            type="button"
            className="btn btn-primary rounded mb-3"
            style={{ minHeight: 36, minWidth: '100%' }}
            onClick={() => $addMoreFields()}
          >
            <Fi.FiPlus className="me-2" /> Tambah Item
          </button>
        </div>
      </div>
    </div>
  );
};
